var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from '../../user/index.js';
import { CallPatientStatus } from '../enums/call-patient.enum.js';
import { CallFullSizeDto } from './call.full-size.dto.js';
export class CallPatientFullSizeDto {
    id;
    createdAt;
    updatedAt;
    patientId;
    callId;
    call;
    patient;
    hasConnected;
    isAllowedEntry;
    /**
     * Transient field — the participant's acknowledgement lives on
     * `AppointmentParticipant.status` since the 2026-04 refactor. The call
     * response mapper populates this from the linked appointment so existing
     * per-patient UI keeps working; undefined when not loaded.
     */
    status;
    /**
     * Transient field — magic-link invite token sourced from the linked
     * `AppointmentParticipant`. Populated by the mapper when available.
     */
    inviteToken;
}
__decorate([
    IsString(),
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CallPatientFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CallPatientFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CallPatientFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", String)
], CallPatientFullSizeDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CallPatientFullSizeDto.prototype, "callId", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => CallFullSizeDto),
    Expose(),
    __metadata("design:type", CallFullSizeDto)
], CallPatientFullSizeDto.prototype, "call", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Function)
], CallPatientFullSizeDto.prototype, "patient", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallPatientFullSizeDto.prototype, "hasConnected", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], CallPatientFullSizeDto.prototype, "isAllowedEntry", void 0);
__decorate([
    IsEnum(CallPatientStatus),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallPatientFullSizeDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], CallPatientFullSizeDto.prototype, "inviteToken", void 0);
//# sourceMappingURL=call-patient.full-size.dto.js.map